/**
 * 기본 이름 생성: "Custom Metric {n}" (n: 중복되지 않은 최소 자연수)
 */
export function generateDefaultName(existingNames: string[]): string {
  const BASE_NAME = "Custom Metric"
  let n = 1

  while (existingNames.includes(`${BASE_NAME} ${n}`)) {
    n++
  }

  return `${BASE_NAME} ${n}`
}
